import { faCheck, faTasks, faXmark, faAsterisk, faFileSlash, faListTree } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { ApplicantOfferRequirementTaskLevel, ApplicantOfferRequirementTaskStatus } from 'api-paths-cas';

interface TaskStatusConfig {
  label: string;
  colorScheme: string;
  icon?: IconDefinition;
  variant?: string;
}

export const taskStatusConfig: Record<ApplicantOfferRequirementTaskStatus, TaskStatusConfig> = {
  [ApplicantOfferRequirementTaskStatus.Assess]: {
    label: 'Assess',
    colorScheme: 'blue',
    variant: 'outline',
  },
  [ApplicantOfferRequirementTaskStatus.Satisfied]: {
    label: 'Satisfied',
    colorScheme: 'green',
    icon: faCheck,
  },
  [ApplicantOfferRequirementTaskStatus.Provisional]: {
    label: 'Provisional',
    colorScheme: 'green',
    variant: 'outline',
  },
  [ApplicantOfferRequirementTaskStatus.Condition]: {
    label: 'Condition',
    colorScheme: 'yellow',
    icon: faAsterisk,
  },
  [ApplicantOfferRequirementTaskStatus.Exempt]: {
    label: 'Exempt',
    colorScheme: 'gray',
    variant: 'secondary',
    icon: faFileSlash,
  },
  [ApplicantOfferRequirementTaskStatus.NotSatisfied]: {
    label: 'Not satisfied',
    colorScheme: 'red',
    icon: faXmark,
  },
};

export const readableStatuses = Object.fromEntries(
  Object.entries(taskStatusConfig).map(([key, value]) => [key, value.label]),
) as Record<ApplicantOfferRequirementTaskStatus, string>;

export const statusSelectStyle = Object.fromEntries(
  Object.entries(taskStatusConfig).map(([key, { colorScheme, variant }]) => [
    key,
    { colorScheme, ...(variant && { variant }) },
  ]),
) as Record<ApplicantOfferRequirementTaskStatus, { colorScheme: string; variant?: string }>;

export const assessmentDropdownLabels: Record<ApplicantOfferRequirementTaskStatus, string> = {
  ...readableStatuses,
  [ApplicantOfferRequirementTaskStatus.Assess]: 'Not assessed',
};

export const taskLevelConfig: Record<
  Exclude<ApplicantOfferRequirementTaskLevel, ApplicantOfferRequirementTaskLevel.Off>,
  TaskStatusConfig
> = {
  [ApplicantOfferRequirementTaskLevel.PreOffer]: {
    label: 'Pre-offer task',
    colorScheme: 'purple',
    icon: faTasks,
    variant: 'secondary',
  },
  [ApplicantOfferRequirementTaskLevel.Condition]: {
    label: 'Condition',
    colorScheme: 'yellow',
    icon: faAsterisk,
    variant: 'secondary',
  },
  [ApplicantOfferRequirementTaskLevel.PreEnrolment]: {
    label: 'Enrolment task',
    colorScheme: 'teal',
    icon: faListTree,
    variant: 'secondary',
  },
  // TODO: probably has to change.
  [ApplicantOfferRequirementTaskLevel.AlwaysAvailable]: {
    label: 'Condition',
    colorScheme: 'yellow',
    icon: faAsterisk,
    variant: 'secondary',
  },
};

export const readableTaskLevels = Object.fromEntries(
  Object.entries(taskLevelConfig).map(([key, value]) => [key, value.label]),
) as Record<string, string>;

export const taskLevelSelectStyle = Object.fromEntries(
  Object.entries(taskLevelConfig).map(([key, { colorScheme, variant }]) => [
    key,
    { colorScheme, ...(variant && { variant }) },
  ]),
) as Record<string, { colorScheme: string; variant?: string }>;
